// 首页 / shop 接口分类页 / 商品详情 共用 SEO（表格「网页界面目录」）
export const homepagePageSeo = {
  tagTitle: "Soluzioni complete dal produttore cinese al tuo magazzino",
  tagDescription:
    "Importi dalla Cina in modo semplice e sicuro. Rakumart offre soluzioni complete di approvvigionamento e logistica dal produttore al tuo magazzino. Richiedi un preventivo!",
  h1Key: "中国进口：一站式采购与物流解决方案",
};

// 商品详情页 SEO
export const productDetailsPageSeo = homepagePageSeo;

// shop 接口动态分类路由 SEO（与首页一致）
export const shopGroupCategoryPageSeo = homepagePageSeo;

// 判断是否为 shop 动态分类路由并返回对应 SEO
export function getShopGroupCategoryPageSeo(route) {
  if (route && route.meta && route.meta.isShopGroupRoute) {
    return shopGroupCategoryPageSeo;
  }
  return null;
}

// 取 shop 分类页 sr-only h1 的中文 key
export function getShopGroupCategoryH1Key(route) {
  const seo = getShopGroupCategoryPageSeo(route);
  return seo && seo.h1Key ? seo.h1Key : "";
}
